export const AiChatMessageVariants = Object.freeze({
    Ai: 'ai',
    User: 'user',
    AiInfo: 'ai-info',
    UserInfo: 'user-info'
});

export type AiChatMessageVariant = (typeof AiChatMessageVariants)[keyof typeof AiChatMessageVariants];
